import React, { useState, useEffect } from "react"
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Link,
  useMediaQuery
} from "@mui/material"
import { lightBlue } from "../../../../../mp-core/themes/palette"
import { CloseIcon } from "../../../../../mp-core/icons"
import { useTheme } from "@mui/material/styles"
import { makeStyles } from "tss-react/mui"

import ReactPlayer from "react-player"
import { AnnouncementsItemType } from "../../../../../mp-database/contextHelpManager"

const styles = makeStyles()(({ breakpoints, spacing, zIndex }) => ({
  learnMoreDialogTitle: {
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 16px 8px 10px",
    "& > :first-of-type": {
      marginRight: "12px"
    },
    "& > :last-child": {
      color: "#37474F",
      fontSize: "1.125rem",
      fontWeight: 500
    }
  }
}))

interface LearnMoreModalProps {
  open?: boolean
  selectedItem?: AnnouncementsItemType
  onClose?: () => void
}

const LearnMoreModal: React.FC<
  React.PropsWithChildren<LearnMoreModalProps>
> = props => {
  const { selectedItem, open = false, onClose } = props
  const { classes } = styles()
  const theme = useTheme()
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"))

  function handleModalOpen() {
    onClose?.()
  }

  return (
    <Dialog
      open={open}
      onClose={handleModalOpen}
      fullWidth={true}
      fullScreen={isSmallDevice}
      keepMounted={false}
      maxWidth={"lg"}
    >
      <DialogTitle className={classes.learnMoreDialogTitle}>
        <IconButton onClick={handleModalOpen} size="large">
          <CloseIcon
            style={{
              color: "#5E7A88",
              fontSize: "1rem"
            }}
          />
        </IconButton>
        {(selectedItem?.learnMoreItem?.title && (
          <Typography>{selectedItem?.learnMoreItem?.title}</Typography>
        )) ||
          null}
      </DialogTitle>
      <DialogContent>
        <Box marginBottom={5}>
          <Grid container spacing={6}>
            {(selectedItem?.videoUrl && (
              <Grid item xs={12} md={6}>
                <Box>
                  <ReactPlayer url={selectedItem?.videoUrl} width="100%" />
                </Box>
              </Grid>
            )) ||
              null}

            <Grid item xs={12} md={selectedItem?.videoUrl ? 6 : 12}>
              <Box>
                {(selectedItem?.learnMoreItem?.message && (
                  <Typography variant="body1">
                    {selectedItem?.learnMoreItem?.message}
                  </Typography>
                )) ||
                  null}
              </Box>

              {(selectedItem?.modalResourcesVideo?.length && (
                <Box marginTop={5}>
                  <Box marginBottom={2}>
                    <Typography>
                      {selectedItem?.modalResourcesVideo?.length > 1 &&
                      selectedItem.modalRelatedResourcesTitle
                        ? selectedItem.modalRelatedResourcesTitle
                        : "Related Resources"}
                    </Typography>
                  </Box>
                  {selectedItem?.modalResourcesVideo.map((resource, index) => (
                    <Link
                      key={resource.name}
                      href={resource.url}
                      target="_blank"
                      style={{ color: lightBlue[700], display: "flex" }}
                    >
                      {resource?.name || ""}
                    </Link>
                  ))}
                </Box>
              )) ||
                null}
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default LearnMoreModal
